import React from "react";
import { createStyles, makeStyles, Typography, withStyles } from "@material-ui/core";
import type { ToggleButtonGroupProps, ToggleButtonProps } from "@material-ui/lab";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";

import type { CoretexTheme } from "../theme";

const useStyles = makeStyles((theme: CoretexTheme) => ({
  selected: {
    "&$selected": {
      backgroundColor: theme.palette.mono.superLightGray,
      color: theme.palette.colour.primaryBlue,
      borderColor: `${theme.palette.colour.primaryBlue} !important`,
      "&:hover": { backgroundColor: theme.palette.mono.superLightGray },
    },
  },
  root: {
    border: `1px solid ${theme.palette.mono.gray}`,
    backgroundColor: theme.palette.mono.white,
    color: theme.palette.mono.primaryDark,

    cursor: "pointer",
    borderRadius: "100px",
    marginRight: theme.spacing(2),
    padding: theme.spacing(0.5, 2),
    "&:hover": { backgroundColor: theme.palette.mono.white },
    textTransform: "none",
    fontSize: "12px",
  },
  count: {
    paddingLeft: "10px",
    fontWeight: theme.typography.fontWeightBold as number,
    fontSize: "12px",
  },
}));

interface IconFilterButtonProps extends ToggleButtonProps {
  count?: number;
}

export const IconFilterButton = ({ count, children, ...props }: IconFilterButtonProps): JSX.Element => {
  const classes = useStyles();

  return (
    <ToggleButton {...props} classes={{ selected: classes.selected, root: classes.root }} disableRipple>
      {children}
      {count != null && <Typography className={classes.count}>{count}</Typography>}
    </ToggleButton>
  );
};

const styles = (theme: CoretexTheme) => ({
  grouped: {
    "&:not(:first-child)": {
      borderRadius: "100px",
      borderColor: theme.palette.mono.gray,
      marginLeft: "0px",
    },
    "&:first-child": {
      borderColor: theme.palette.mono.gray,
      borderRadius: "100px",
    },
  },
});

const IconFilterGroup: React.ComponentType<ToggleButtonGroupProps> = withStyles(createStyles(styles))(
  ToggleButtonGroup,
);

export default IconFilterGroup;
